import { makeStyles, mergeClasses, shorthands } from "@fluentui/react-components";

import { StyleConstants } from "../Shared/Styles/StyleConstants";
import { themeTokens } from "Core/Theme";
import { M365PulseSiteLayoutState } from "./M365PulseSiteLayout.types";

export const useM365PulseSiteLayoutMainStyle = makeStyles({
    root: {
        boxSizing: "border-box",
        position: "relative"
    },
    header: {
        position: "absolute",
        height: `${StyleConstants.headerHeight}px`,
        width: "calc(100vw)",
        ...shorthands.overflow("hidden"),
        ...shorthands.borderBottom("0")
    },
    leftBar: {
        position: "absolute",
        top: `${StyleConstants.headerHeight}px`,
        width: `${StyleConstants.leftBarWidth}px`,
        height: `calc(100vh - ${StyleConstants.headerHeight}px)`,
        overflowX: "hidden",
        overflowY: "hidden",
        backgroundColor: themeTokens.colorNeutralBackground3
    },
    appRootMain: {
        backgroundColor: themeTokens.colorNeutralBackground1
    },
    appRoot: {
        left: `${StyleConstants.leftBarWidth}px`,
        overflowX: "hidden",
        position: "absolute",
        top: `${StyleConstants.headerHeight}px`,
        height: `calc(100vh - ${StyleConstants.headerHeight}px)`,
        width: `calc(100vw - ${StyleConstants.leftBarWidth}px)`,
        overflowY: "hidden",
        display: "flex"
    },
    appContent: {
        ...shorthands.flex(1),
        overflowY: "auto"
    },
    appContentMinWidth: {
        minWidth: `${StyleConstants.appContentMinWidth}px`
    },
    appContentMinWidthUnset: {
        minWidth: "unset"
    },
    skipToMainContent: {
        position: "absolute",
        top: "10px",
        left: "-9999px",
        zIndex: 999,
        opacity: 0,
        color: "white",
        ":focus": { left: "20%", opacity: 1, transform: "translateX(-20%)" }
    }
});

const useM365PulseSiteLayoutSmallStyle = makeStyles({
    appRoot: {
        left: 0,
        width: "100%",
        position: "absolute",
        top: `${StyleConstants.headerHeight}px`,
        height: `calc(100vh - ${StyleConstants.headerHeight}px)`,
        overflowY: "auto"
    }
});

export const useM365PulseSiteLayoutStyle = (state: M365PulseSiteLayoutState) => {
    const { isSmallScreen, isOpsGeniePanelOpen } = state;
    const styles = useM365PulseSiteLayoutMainStyle();
    const smallStyles = useM365PulseSiteLayoutSmallStyle();

    styles.appRootMain = mergeClasses(styles.appRootMain, isSmallScreen ? smallStyles.appRoot : styles.appRoot);
    styles.appContent = mergeClasses(styles.appContent, !isSmallScreen && isOpsGeniePanelOpen ? styles.appContentMinWidth : styles.appContentMinWidthUnset);

    return styles;
};
